import { API_HOST_ORGS, API_HOST_QUALS, API_HOST_REFDATA, API_HOST_SEARCH } from "../config";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import { AwardingOrgService } from "./AwardingOrgService";
import { QualificationService } from "./QualificationService";
import { SectorSubjectAreaService } from "./SectorSubjectAreaService";
import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { LevelsService } from "./LevelsService";
import { QualificationTypeService } from "./QualificationTypeService";
import { ApprenticeshipStandardsService } from "./ApprenticeshipStandardsService";
import availabilityStatus from "./json/availabilityStatus.json";
import { AssessmentMethodsService } from "./AssessmentMethodsService";
import { EntitlementFrameworkDesignationService } from "./EntitlementFrameworkDesignationService";
import { GradingScalesService } from "./GradingScalesService";
import { OverallGradingTypeService } from "./OverallGradingTypeService";

export const qualificationService = new QualificationService(API_HOST_QUALS);

export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const sectorSubjectService = new SectorSubjectAreaService(API_HOST_REFDATA);
export const levelsService = new LevelsService(API_HOST_REFDATA);
export const cachedLevelsService = cachingService(
  levelsService
);
export const qualificationTypeService = new QualificationTypeService(API_HOST_REFDATA);
export const cachedQualificationTypeService = cachingService(
  qualificationTypeService
);
export const apprenticeshipStandardsService = new ApprenticeshipStandardsService(API_HOST_REFDATA);
export const overallGradingTypeService = new OverallGradingTypeService(API_HOST_REFDATA);
export const gradingScalesService = new GradingScalesService(API_HOST_REFDATA);
export const assessmentMethodsService = new AssessmentMethodsService(API_HOST_REFDATA);
export const entitlementFrameworkDesignationService = new EntitlementFrameworkDesignationService(API_HOST_REFDATA);
export const availabilityStatusService = new LocalLookupService(availabilityStatus);